import { ContentArticle } from '../types';
import banner from '../assets/release.jpg';
import { Author } from '../authors/trey';

const body = (<div dangerouslySetInnerHTML={{ __html: `<p>We decided to spend another sprint working on performance. We also felt the UI needed improvement, especially where we had buttons with flat designs that looked the same as information icons - with flat designs. We did a facelift on that, so it should be significantly more clear what's clickable and what's not.</p>
<p>Check out all the specific changes in this release. You don't really need to read this, just download it and get started.</p>
<ul>
<li>Roll out an updated user interface, cleaner and clearer for hosts</li>
<li>Improved the algorithm we use in our WebRTC peer manager to produce even better upgrade and downgrade of the media stream based on player device and current network conditions</li>
<li>Further optimizations to desktop capture - even faster now!</li>
<li>We worked out how to use CPU core affinities, managing them to reduce CPU utilization when capturing the desktop</li>
<li>Implemented a logging socket server in order to have a debug tool (that's not in the release, but was super helpful in getting out this release)</li>
</ul>
` }} className="article" />);

export const Release1x2x0: ContentArticle = {
  title: `Release Notes: v1.2.0`,
  slug: `release-1-2-0`,
  published: `2024-11-28`,
  author: Author,
  banner: banner,
  summary: `Here comes v1.2 - another run at better performance, plus updated and clearer UI`,
  body: body,
};
